// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1sB-3","modalForm":"UpgradeEpcsModal_modalForm__10yvy","modalFooter":"UpgradeEpcsModal_modalFooter__1pUVc"};